import React, { useEffect, useState } from "react";
import {
  Box,
  CssBaseline,
  Grid,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import "firebase/auth";
import { useNavigate } from "react-router-dom";

import {
  drawerWidth,
  GeneralAdminRoutes,
  mainLayoutStyles,
  routes,
  showNotification,
} from "../../../../../constants";
import Header from "../../../../../common/Header";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";

import { useAlbumsContext } from "../../../../../providers/OrganizationAdmin/AlbumProvider";

import { Toast } from "../../../../../common/alert";
import {
  AlbumsTable,
  FilterSection,
  SearchBar,
} from "../../components/components";
import ConfirmationModal from "../../../../../common/ConfirmationModal";
import FilterModalComponent from "../../../../../common/FilterModalComponent";
import {
  albumsSearch,
  updateAlbum,
  deleteAlbum,
} from "../../../../../modules/OrganizationAlbums/hooks/AlbumsHooks";
import { useAuth } from "../../../../../hooks";
import { getDateRange } from "../../../../../modules/OrgProf/hook/Organizationhook";
import { getFilterAlbums } from "../../hooks/AlbumsHooks";

const GAAlbumsContainer = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { handleGetAllGAAlbums, allGAAlbums, setLoading, loading } =
    useAlbumsContext();

  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [statusFilterOptions, setStatusFilterOptions] = useState([]);
  const [creationDateFilterOptions, setCreationDateFilterOptions] = useState(
    []
  );

  const [albumsData, setAlbumsData] = useState([]);

  console.log("albumss::", albumsData);


  //Qaiser do not remove this useEffect I changed it like this.
  useEffect(() => {
    handleGetAllGAAlbums();
  }, []);

  useEffect(() => {
    setAlbumsData(allGAAlbums);
  }, [allGAAlbums]);

  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setFilterModal(false);
  };
  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };
  const handleDeleteModalClose = () => {
    setDeleteModal(false);
  };

  const handleDeleteChip = (filterType, filterItem) => {
    if (filterType === "status") {
      setStatusFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "creationDate") {
      setCreationDateFilterOptions([]);
      // setCreationDateFilterOptions((prevOptions) => prevOptions.filter((item) => item !== filterItem));
    }
  };

  useEffect(() => {
    handleFilterAlbums();
  }, [statusFilterOptions, creationDateFilterOptions]);

  const handleFilterAlbums = async () => {
    // let organizationUserId = currentUser?.organization ? currentUser.id : "";

    // let dateRange = getDateRange(creationDateFilterOptions);
    let dateRange;
    if (creationDateFilterOptions && creationDateFilterOptions.length > 0) {
      dateRange = getDateRange(creationDateFilterOptions);
    }
    setSelected([]);
    if (
      creationDateFilterOptions.length > 0 ||
      statusFilterOptions.length > 0
    ) {
      let temp = await getFilterAlbums(
        // whoCanListenFilterOptions,
        dateRange,
        statusFilterOptions,
        setLoading,
        handleFilterModalClose
      );
      setAlbumsData([...temp]);
    }
    if (
      creationDateFilterOptions.length === 0 &&
      statusFilterOptions.length === 0
    ) {
      console.log("here");
      setAlbumsData(allGAAlbums);
    }
  };

  const handleDeleteAlbum = async () => {
    try {
      setLoading(true);

      selected.forEach(async (item) => {
        let responseTemp = await deleteAlbum(item);
      });
      await handleGetAllGAAlbums();
      setSelected([]);
      showNotification("Album deleted successfully.");
      // Toast("success", "Album deleted successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error deleting quicktale", error.message);
    } finally {
      setLoading(false);
      handleDeleteModalClose();
    }
  };

  const handleUpdateAlbumStatus = async (privacy) => {
    // console.log("handleUpdateAlbumStatus", handleUpdateAlbumStatus);
    try {
      setLoading(true);
      let dataTemp = {
        privacy,
        updatedAt: new Date(),
        updatedBy: currentUser?.userName,
      };
      selected.forEach(async (item) => {
        // console.log("item", item);
        let responseTemp = await updateAlbum(item, dataTemp);
        console.log("update album response:", responseTemp);
      });
      await handleGetAllGAAlbums();
      setSelected([]);

      showNotification("Album updated successfully.");
      // Toast("success", "Album updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating album", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateAlbumApprovalStatus = async (privacy) => {
    try {
      setLoading(true);
      let dataTemp = {
        privacy,
        updatedAt: new Date(),
        updatedBy: currentUser?.userName,
      };
      selected.forEach(async (item) => {
        let responseTemp = await updateAlbum(item, dataTemp);
        console.log("update album response:", responseTemp);
      });
      await handleGetAllGAAlbums();
      setSelected([]);
      showNotification("Album updated successfully.");
      // Toast("success", "Album updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating album", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchAlbums = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        let albumsSearchTemp = await albumsSearch(allGAAlbums, value);
        setAlbumsData(albumsSearchTemp);
      } else {
        setAlbumsData(allGAAlbums);
      }
    } catch (error) {
      console.log("error searching album:", error.message);
    }
  };

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  const resetFilter = async () => {
    setStatusFilterOptions([]);
    setCreationDateFilterOptions([]);
    setAlbumsData(allGAAlbums);
    setSelected([]);
  };

  return (
    <Box sx={{ display: "flex", width: `calc(100% - ${drawerWidth}px)` }}>
      <CssBaseline />
      <Header
        mainTitle={"Albums"}
        bgColor="#fff"
        buttonText={"Add Album"}
        handleSubmit={() => navigate(GeneralAdminRoutes.addGAAlbum)}
      />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          <FilterSection
            handleFilterModalOpen={handleFilterModalOpen}
            statusFilterOptions={statusFilterOptions}
            creationDateFilterOptions={creationDateFilterOptions}
            handleDeleteChip={handleDeleteChip}
          />
          <SearchBar
            selected={selected}
            setSelected={setSelected}
            placeholder={"Search QT Title, Album By, QT Created By"}
            handleUpdateAlbumStatus={handleUpdateAlbumStatus}
            handleSearch={handleSearchAlbums}
            handleUpdateAlbumApprovalStatus={handleUpdateAlbumApprovalStatus}
            handleDeleteAlbum={handleDeleteModalOpen}
          />

          <AlbumsTable
            // allGAAlbums={allGAAlbums}
            selected={selected}
            setSelected={setSelected}
            albumsInOrg={albumsData}
            setAlbumsInOrg={setAlbumsData}
          />
        </Grid>
      </Grid>{" "}
      <ConfirmationModal
        modalOpen={deleteModal}
        handleClose={handleDeleteModalClose}
        handleClick={handleDeleteAlbum}
        title={"Are you sure to delete the selected Album(s)?"}
      />
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={handleFilterAlbums}
        data={[
          {
            mainOptions: creationDateFilterOptions,
            setMainOptions: setCreationDateFilterOptions,
            type: "date",
            title: "Creation Date",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Today", selected: false },
              { label: "Past Week", selected: false },
              { label: "Last 30 Days", selected: false },
              { label: "Last 12 Months", selected: false },
              { label: "Enter a Range", selected: false },
            ],
          },
          {
            mainOptions: statusFilterOptions,
            setMainOptions: setStatusFilterOptions,
            type: "text",
            title: "Who Can Listen",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Public", selected: false },
              { label: "Private", selected: false },
              { label: "Unlisted", selected: false },
            ],
          },
        ]}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default GAAlbumsContainer;
